// extracted by mini-css-extract-plugin
module.exports = {"opacityBar1":"ScrollOpacity-module--opacityBar1--15PdD","opacityBar2":"ScrollOpacity-module--opacityBar2--19Xh4"};